import { IDocument, IEntity } from '@pf/shared-common';
import {
    CategoryViewModelRead,
    ItemBrandViewModel,
    ItemEntitySearchRequestParams,
    ItemViewModelBody,
    ItemViewModelRead,
    ResourceAuth,
} from '@control-tower/platform-item-catalog';
import { asArraySafe } from '@pf/shared-utility';
import { ICustomFieldDto } from '@pf/shared/util-platform';
import { ItemWarehouseAmountDto } from './item-warehouse-amount.dto';
import {
    PackSizeUom,
    ReplenishmentStrategy,
} from '@control-tower/platform-wms';

export type ItemRead = Omit<ItemViewModelRead, 'files'> & {
    warehouseAmounts?: ItemWarehouseAmountDto[] | null;
    files?: IDocument[] | null;
} & IEntity;
export type ItemCreate = ItemViewModelBody & {
    warehouseAmounts?: ItemWarehouseAmountDto[] | null;
};
export type ItemSearchParams = ItemEntitySearchRequestParams;
export type CategoryViewModelDto = Omit<
    CategoryViewModelRead,
    'resourceAuth' | 'parentCategory'
> &
    IEntity;

export class ItemDto implements IEntity {
    constructor(data: Partial<ItemDto>) {
        Object.assign(this, data);
        if (data.assignedCategories) {
            this.assignedCategories = asArraySafe(data.assignedCategories);
        }
        if (data.warehouseAmounts) {
            this.warehouseAmounts = asArraySafe(data.warehouseAmounts);
        }
        if (data.files) {
            this.files = asArraySafe(data.files);
        }
    }

    id!: string;
    name!: string;
    code?: string;
    description?: string;
    brandId?: string;
    brand?: ItemBrandViewModel;
    parentItemId?: string;
    sku?: string;
    modelNumber?: string;
    partNumber?: string;
    isBreakPack?: boolean;
    hasInstances?: boolean;
    packSize?: number;
    maxGroupSize?: number;
    hazardous?: boolean;
    weight: ItemRead['weight'];
    dimensions: ItemRead['dimensions'];
    assignedCategories?: CategoryViewModelDto[];
    vendorSku?: string | null;
    replenishmentStrategy?: ReplenishmentStrategy;
    defaultMinQuantity?: number | null;
    defaultMaxQuantity?: number | null;
    velocity?: string | null;
    packSizeUom?: PackSizeUom;
    resourceAuth?: ResourceAuth;
    isDeleted?: boolean;
    customFields?: ICustomFieldDto[];
    parentItemName?: string;
    manufacturerName?: string;
    warehouseAmounts?: ItemWarehouseAmountDto[];
    files?: IDocument[] | null;
}
